<style>
    @import "./vip.less";
</style>
<template>
    <div class="lawtelephone">
        <div class="lawt_con">
            <img src="./lawcomponent/images/lawjudgeback.png" alt='版权登记'/>
        </div>
        <div class="lawt_fr_content">
            <img src="./lawcomponent/images/lawContrant1.png" alt='版权登记'/>
            <div class="lawt_fr_content_rig">
                <p class="rg_title">合同审核</p>
                <p class="rg_tw_title">由专业律师提供各类合同的审核服务，单份合同限5000字以内</p>
                <div style="margin-top:40px;">
                    <p class="rg_tw_title">请选择类型:</p>
                    <div style="margin-top:15px;">
                        <input @click="contractTypeValue = item.value" v-for="(item,index) in contractType"
                               :class="item.value == contractTypeValue ? 'active' : '' " type="button"
                               :value="item.name" :key="index"/>
                    </div>
                </div>
                <p v-if="lawyerConsultNum>0" class="vipstyle">您是{{ userInfo.accountType == 'person' ? '个人' : '企业'
                    }}VIP会员，当前剩余{{lawyerConsultNum}}次法律服务</p>
                <input class="goOrderEsc" @click="oneSubmit" type="button" value="下单"/>
            </div>
        </div>
        <div class="lawt_parcontent">
            <div class="lawt_cont_title">
                <div>您可能还需要以下服务</div>
                <p></P>
            </div>
            <div style="padding-top:212px">
                <lawCommon active-id="2"/>
            </div>
        </div>
        <div class="lawJudgement_three">
            <div class="law_thre_content">
                <p class="th_title">C<br/>O<br/>P<br/>Y<br/>R<br/>I<br/>G<br/>H<br/>T</p>
                <img src="./lawcomponent/images/lawjudge1.png" alt='版权登记'/>
                <div class="th_thcontent">
                    <img style="margin-top:60px;" src="./lawcomponent/images/lawjudge5.png" alt='版权登记'/>
                    <p style="margin-top:30px;" class="th_pf">根据《著作权法》第48条的规定</p>
                    <p style="margin-top:30px;" class="th_ps">侵犯著作权，侵权人应当按照权利人的实际损失给予赔偿</p>
                    <p style="margin-top:15px;margin-bottom:15px;" class="th_ps">实际损失难以计算的，不能确定的，由人民法院根据侵权行为</p>
                    <p class="th_ps">的情节，判决给予50万元以下的赔偿。</p>
                </div>
            </div>
        </div>
        <div class="lawContract_four">
            <div class="lawContract_four_content">
                <div class="th_thcontent">
                    <div class="tongyong_top">
                        <p>合同审核的重要性</p>
                        <div></div>
                    </div>
                    <div class="lawContractleft">
                        <p>白纸黑字</p>
                        <p style="margin-bottom:40px;">明确双方权益和责任，避免口头承诺无法实现</p>
                    </div>
                    <div class="lawContractleft">
                        <p>呈堂证供</p>
                        <p>一旦产生纠纷，签过字的合同课作为法庭上的证据</p>
                    </div>
                </div>
                <img style="margin-right:17px;" src="./lawcomponent/images/lawContrant3.png" alt='版权登记'/>
                <p class="th_title">C<br/>O<br/>P<br/>Y<br/>R<br/>I<br/>G<br/>H<br/>T</p>
            </div>
        </div>
        <div class="lawtbo_content" style="padding-top:53px;padding-bottom:50px">
            <lawcommontw :content="content" :title="title"/>
            <img src="./lawcomponent/images/lawtele1.png" alt='版权登记'/>
        </div>

        <!--    合同审核模态框    -->
        <generalframe @fatherMethod="fatherMethod" v-show="showDialog" myheight="650" mywidth="800" maintitle="合同审核"
                      ref="mychild">
            <div class="ts_content">
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>接听手机：</p>
                    <input v-model="callbackMobilePhone" style="flex:1" type="text" maxLength="11"
                           placeholder="请输入11位手机号码"/>
                </div>
                <div class="ts_content_fr" style="margin-bottom:30px;">
                    <p>上传合同：</p>
                    <MyUploadHw
                            v-show="statementList.length == 0 ?
                                         true :
                                         statementList[0].status ?
                                         statementList[0].status == 'uploading' ?
                                         false :
                                         true :
                                         true "
                            ref="stateFile"
                            :oldShowList="statementList"
                            :fileMultiue="false"
                            :documnetTypes="20971520"
                            :pictureTypes="20971520"
                            :videoAndMusics="20971520"
                            :otherTypes="20971520"
                            styleType="btn"
                            @listentochildevent="showmessagefromchild2"/>

                    <div class="upload_progress_one" v-if="statementList.length == 0 ?
                                         false :
                                         statementList[0].status ?
                                         statementList[0].status == 'uploading' ?
                                         true :
                                         false :
                                         false ">
                        上传中 {{ statementList[0].uploadProgress }}%

                        <div :style="{width:statementList[0].uploadProgress + '%'}"
                             class="upload_progress_one_shadow"></div>
                    </div>

                    <Tooltip max-width="400" v-if="contractUrl && contractUrl!='' " placement="top" :content="fileName">
                        <span class="shoetext">{{ fileName }}</span>
                    </Tooltip>
<!--                    <div :title="fileName" class="shoetext" v-model="contractUrl">{{fileName}}</div>-->
                    <input style="flex:1;display:none;" type="text" placeholder="请输入下架链接"/>
                </div>
                <div class="ts_content_fr">
                    <p>描述：</p>
                    <textarea maxlength="500" v-model="questionDesc"
                              style="flex:1;min-height:120px;resize: none;padding: 5px;"
                              placeholder="请输入您需要判定的简要描述"></textarea>
                </div>
                <div v-if="showDialog" style="line-height: 42px;margin-top: 30px;" class="ts_content_fr">
                    <p>支付方式：</p>
                    <pay-way
                            @onselected="payWay = $event"
                            type="0503">
                    </pay-way>
                </div>
                <input class="goOrderEsc" @click="sureOrder" type="button" value="确认下单"/>
            </div>
        </generalframe>
        <!--    加油包    -->
        <monitorBag bizType="05" v-if="monitorBagState" @monitorBagFather="monitorBagFuc"/>
        <!--    会员续费    -->
        <myczPay v-if="myczPayState" mywidth='838' myheight="585" myTitleheight="50" @fatherModal="myczPayFuc"/>
    </div>
</template>
<script>
    import lawcommontw from './lawcomponent/lawcomponenttw.vue'
    import lawCommon from './lawcomponent/lawcomponentbl.vue'
    import generalframe from './lawcomponent/generalframe.vue'
    import monitorBag from '@/views/vipClip/monitor/components/monitorBag';
    import myczPay from '@/views/vipClip/vip/lawcomponent/myczpay'
    import Cookies from "js-cookie";
    import {getContractAudit, getVipMemberright} from '@/api/staticPage';
    import util from '@/libs/util';
    import payWay from '@/views/main-components/pay-way';
    import MyUploadHw from '@/views/main-components/my-upload-hw';

    export default {
        metaInfo: {
            title: '合同审核|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '合同审核,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: 'lawContract',
        components: {
            lawcommontw,
            lawCommon,
            generalframe,
            monitorBag,
            myczPay,
            payWay,
            MyUploadHw
        },
        data() {
            return {
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                contractType: [
                    {name: '合同审核', value: 'contract_audit'},
                    {name: '代写合同', value: 'contract_ghostwrite'}
                ], //合同审核类型
                contractTypeValue: 'contract_audit', //合同审核类型值
                content: [
                    {content: '预约律师，确认下单', english: 'ONE'},
                    {content: '等待律师，电话联系', english: 'TWO'},
                    {content: '双方沟通，解答问题', english: 'THREE'},
                    {content: '服务完成，平台回访', english: 'FOUR'},
                ],
                title: '律师服务流程',
                records: [
                    {
                        content: '一次付费咨询可以通话多久？',
                        reContent: '通话时长应控制在30分钟以内，如超出时间，律师课选择结束咨询。'
                    },
                    {
                        content: '下单后谁会联系我？',
                        reContent: '下单后，律师会给您回电话，我们要求律师在20分钟内响应。'
                    },
                    {
                        content: '律师超时未联系怎么办？',
                        reContent: '有时律师可能因为开庭等事项无法及时响应，如果超时未响应，请联系平台客服，版权家客服经理会为您协调更换律师。'
                    },
                    {
                        content: '咨询律师前需要准备什么？',
                        reContent: '为了高效利用您的咨询时间，请在下单前尽可能把您需要准备的问题梳理清楚。'
                    },
                    {
                        content: '和律师沟通后，有意向委托律师服务，该怎么办？',
                        reContent: '如果是合同、侵权下架等平台已有的服务，您可以直接在平台下单即可，如果平台上没有的产品您可以联系平台客服，平台客服经理会为您安排。'
                    },
                ],
                showDialog: !1,
                questionDesc: '',
                callbackMobilePhone: '',
                contractUrl: '',
                uploadList: [],
                accessKeyId: '',
                accessKeySecret: '',
                stsToken: '',
                md5Hash: '',
                fileName: '',
                lawyerConsultNum: 0, //法律服务次数
                monitorBagState: false, //加油包模态框展示状态
                myczPayState: false, //会员监测模态框展示状态
                payWay: null,
                statementList: [],
            }
        },
        watch: {
            "$store.state.app.showPayWay": function () {
                if (Cookies.get("userInfo")) {
                    this.userInfo = JSON.parse(Cookies.get("userInfo"))
                }
            }
        },
        methods: {
            _getContractAudit() {
                let _this = this;
                let userInfo = Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '';
                let params = {
                    registerId: userInfo && userInfo.id ? userInfo.id : '',
                    callbackMobilePhone: _this.callbackMobilePhone,
                    questionDesc: _this.questionDesc,
                    contractUrl: _this.contractUrl,
                    contractType: _this.contractTypeValue
                };
                console.log(this.payWay);
                if (this.payWay && this.payWay.gift && this.payWay.gift.countNumber) {
                    Object.assign(params, {activityGiftId: this.payWay.activityGiftId && this.payWay.activityGiftId != '' ? this.payWay.activityGiftId : ''})
                } else {
                    toast('无可用次数')
                    return;
                }
                getContractAudit(params).then(res => {
                    //1.用户未实名；2.VIP未开通；3.VIP已到期；4.加油包

                    switch (res.code) {
                        case 200 : {
                            _this.lawyerConsultNum = _this.lawyerConsultNum - 1;
                            _this.fatherMethod();
                            toast('提交成功！请前往【个人中心】查看订单服务详情');
                            break;
                        }

                        //VIP已到期--弹框
                        case 215: {
                            toast(message, () => {
                                this.myczPayState = true;
                            });
                            break;
                        }

                        //次数不够--弹出加油包
                        case 216 : {
                            this.monitorBagState = true;
                            break;
                        }

                        default:
                            toast(message);
                            break;

                    }


                }, (err) => {
                    toast('提交失败，请重试');
                })
            },

            /************服务次数接口***********/
            _getVipMemberright() {
                let _this = this;
                let userInfo = this.userInfo;

                if (userInfo && userInfo != '' && userInfo.vipFlag != 0) {
                    let params = {
                        registerId: userInfo && userInfo.id ? userInfo.id : '',
                    };
                    getVipMemberright(params).then(res => {
                        if (res.code == 200) {
                            this.lawyerConsultNum = res.result.lawyerConsultNum;
                        }
                    })
                }

            },

            goOrder() {
                let _this = this;
                _this.showDialog = !0
            },

            fatherMethod() {
                let _this = this;
                _this.showDialog = !1;
                _this.callbackMobilePhone = '';
                _this.questionDesc = '';
                _this.contractUrl = '';
                _this.fileName = '';
            },
            sureOrder() {
                let _this = this;
                let contractUrl = _this.contractUrl.replace(/^\s+|\s+$/g, '');
                let questionDesc = _this.questionDesc.replace(/^\s+|\s+$/g, '');
                if (!util.checkPhoneNum(_this.callbackMobilePhone)) {
                    toast('请填写正确的手机号再提交');
                } else if (questionDesc == '' || contractUrl == '') {
                    toast('请填写完整后再提交');
                } else {
                    _this._getContractAudit()
                }

            },

            //上传合同
            showmessagefromchild2(data) {
                let _this = this;

                if (data[0].status && data[0].status == 'uploading') {
                    // console.log('没完成')
                } else {
                    let layout = data[0].attachmentUrl.substring(data[0].attachmentUrl.lastIndexOf('.') + 1)
                    _this.declare_upload_success = true;
                    _this.contractUrl = data[0].attachmentUrl
                    _this.fileName = data[0].name;

                }
                _this.statementList = data
                this.$forceUpdate()
            },

            /****************接收加油包组件传值**************/
            monitorBagFuc(value) {
                this.monitorBagState = false;
            },

            /****************接收会员续费组件传值**************/
            myczPayFuc() {
                console.log('会员续费弹框');
                this.myczPayState = false;
            },

            oneSubmit() {
                let userInfo = this.userInfo;
//              console.log(userInfo);
                if (!userInfo || userInfo == '') {
                    this.$store.state.app.showLoginOrRegistter = true
                    return false;
                } else if (this.contractTypeValue == '') {
                    console.log(this.contractTypeValue);
                    toast('请选择完整后提交')
                } else {
                    this.goOrder();
                }
            }
        },

        mounted() {
            this._getVipMemberright();
        }
    }
</script>
<style scoped lang="less">
    .lawtelephone {
        // margin-bottom: 200px;
        .lawt_con {
            height: 422px;

            img {
                max-width: 100%;
                display: block;
                height: 100%;
            }
        }

        .lawt_fr_content {
            width: 1334px;
            height: 427px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
            border-radius: 4px;
            left: 0;
            right: 0;
            margin: auto;
            margin-top: -400px;
            z-index: 555;
            position: absolute;
            display: flex;
            justify-content: flex-start;

            img {
                width: 506px;
                height: 383px;
                margin: 22px;
                margin-right: 0px;
            }

            .lawt_fr_content_rig {
                margin-left: 37px;

                .rg_title {
                    height: 28px;
                    font-size: 20px;
                    font-weight: bold;
                    color: rgba(65, 65, 65, 1);
                    line-height: 28px;
                    margin-top: 40px;
                }

                .rg_tw_title {
                    height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(65, 65, 65, 1);
                    line-height: 20px;
                }

                input {
                    width: 137px;
                    height: 42px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 2px;
                    border: 1px solid rgba(199, 199, 199, 1);
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 42px;
                    cursor: pointer;
                    outline: none;
                    margin-right: 20px;
                    margin-bottom: 20px;

                    &:hover {
                        background: rgba(255, 216, 0, 1);
                        border: none;
                        padding: 1px;
                    }

                    &.goOrderEsc:hover {
                        padding: 0;
                    }
                }

                .active {
                    width: 137px;
                    height: 42px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 2px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 42px;
                    cursor: pointer;
                    outline: none;
                    border: none;
                    margin-right: 20px;
                    margin-bottom: 20px;
                    padding: 1px;
                }

                .vipstyle {
                    height: 20px;
                    font-size: 14px;
                    font-weight: bold;
                    color: rgba(37, 37, 37, 1);
                    line-height: 20px;
                    margin-top: 60px;
                }

                .goOrderEsc {
                    margin-top: 20px;
                    width: 137px;
                    height: 42px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 2px;
                    font-size: 14px;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    line-height: 42px;
                    outline: none;
                    border: none;
                    cursor: pointer;
                }
            }
        }

        .lawt_parcontent {
            height: 569px;
            background: rgba(250, 252, 254, 1);

            .lawt_cont_title {
                width: 1334px;
                margin: 0 auto;
                position: relative;
                top: 58px;

                div {
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    z-index: 3;
                    top: 56px;
                    text-align: center;
                    font-size: 30px;
                    font-weight: 400;
                    color: rgba(4, 4, 4, 1);
                    letter-spacing: 3px;
                }

                p {
                    width: 55px;
                    height: 55px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 50%;
                    position: absolute;
                    left: 0;
                    right: 0;
                    margin: auto;
                    z-index: 2;
                    top: 50px;
                }
            }
        }

        .lawtbo_content {
            width: 1334px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
                width: 667px;
                height: 456px;
            }
        }

        .lawtbo_se_content {
            height: 829px;
            background: rgba(250, 252, 254, 1);

            .lawtbo_se_clt {
                width: 1334px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 100%;

                img {
                    width: 434px;
                    height: 629px;
                }

                .lawbojn {
                    width: 900px;
                    height: 629px;
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);
                    border-radius: 2px;

                    .lawbojncontent {
                        margin-left: 36px;
                        margin-top: 10px;

                        .lawbojncontent_top {
                            p {
                                height: 36px;
                                font-size: 25px;
                                font-weight: 400;
                                color: rgba(4, 4, 4, 1);
                                line-height: 36px;
                                letter-spacing: 3px;
                            }

                            .commonbottomDiv {
                                width: 193px;
                                height: 25px;
                                background: rgba(216, 216, 216, 1);
                                opacity: 0.15;
                                margin-top: -20px;
                                margin-bottom: 38px;
                            }

                            .show_no_border {
                                border: none !important;
                            }

                            .show_sea_con {
                                border-bottom: 1px solid rgba(238, 238, 238, 1);

                                .show_sea_con_t {
                                    display: flex;
                                    justify-content: flex-start;
                                    padding-top: 20px;
                                    align-items: center;

                                    .show_answer {
                                        width: 23px;
                                        height: 16px;
                                        background: rgba(255, 98, 70, 1);
                                        border-radius: 2px;
                                        font-size: 11px;
                                        font-weight: bold;
                                        color: rgba(255, 255, 255, 1);
                                        -webkit-transform: scale(0.91);
                                        text-align: center;
                                        line-height: 16px;
                                    }

                                    .show_answer_content {
                                        height: 22px;
                                        font-size: 16px;
                                        font-weight: bold;
                                        color: rgba(51, 51, 51, 1);
                                        line-height: 22px;
                                        margin-left: 15px;
                                        max-width: 800px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                }

                                .show_sea_con_b {
                                    display: flex;
                                    justify-content: flex-start;
                                    margin-top: 11px;

                                    .show_question {
                                        width: 27px;
                                        height: 16px;
                                        background: rgba(72, 131, 247, 1);
                                        border-radius: 2px;
                                        font-size: 11px;
                                        -webkit-transform: scale(0.91);
                                        font-weight: bold;
                                        color: rgba(255, 255, 255, 1);
                                        text-align: center;
                                        line-height: 16px;
                                        margin-top: 3px;
                                    }

                                    .show_question_content {
                                        margin-left: 11px;
                                        max-width: 800px;

                                        .show_question_content_t {
                                            font-size: 14px;
                                            font-weight: 400;
                                            color: rgba(102, 102, 102, 1);
                                            line-height: 22px;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 2;
                                            overflow: hidden;
                                            margin-bottom: 17px;
                                        }

                                        .show_question_content_d {
                                            display: flex;
                                            justify-content: space-between;
                                            align-items: center;
                                            margin-top: 5px;

                                            p {
                                                height: 22px;
                                                font-size: 12px;
                                                font-weight: 400;
                                                color: rgba(153, 153, 153, 1);
                                                line-height: 22px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .lawJudgement_three {
            height: 321px;
            background: rgba(250, 252, 254, 1);

            .law_thre_content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 1334px;
                margin: 0 auto;
                height: 321px;

                .th_title {
                    width: 18px;
                    height: 306px;
                    font-size: 25px;
                    font-weight: 800;
                    color: rgba(216, 216, 216, 1);
                    line-height: 34px;
                }

                img {
                    width: 506px;
                    height: 321px;
                    margin-left: 17px;
                    margin-right: 85px;
                }

                .th_thcontent {
                    height: 321px;

                    img {
                        width: 28px;
                        height: 25px;
                        margin-left: 0px;
                        margin-right: 0px;
                    }

                    .th_pf {
                        height: 28px;
                        font-size: 20px;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 28px;
                    }

                    .th_ps {
                        height: 21px;
                        font-size: 15px;
                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 21px;
                    }
                }
            }
        }

        .lawContract_four {
            margin-top: 50px;
            height: 321px;
            background: rgba(250, 252, 254, 1);

            .lawContract_four_content {
                width: 1334px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;

                .th_title {
                    width: 18px;
                    height: 306px;
                    font-size: 25px;
                    font-weight: 800;
                    color: rgba(216, 216, 216, 1);
                    line-height: 34px;
                }

                .th_thcontent {
                    height: 321px;

                    .tongyong_top {
                        margin-left: 49px;
                        margin-top: 30px;

                        p {
                            height: 36px;
                            font-size: 25px;
                            font-weight: 400;
                            color: rgba(4, 4, 4, 1);
                            line-height: 36px;
                            letter-spacing: 3px;
                        }

                        div {
                            width: 193px;
                            height: 25px;
                            background: rgba(216, 216, 216, 1);
                            opacity: 0.15;
                            margin-top: -20px;
                            margin-bottom: 38px;
                        }
                    }

                    .lawContractleft {
                        margin-left: 49px;

                        p:first-child {
                            height: 28px;
                            font-size: 20px;
                            font-weight: 400;
                            color: rgba(51, 51, 51, 1);
                            line-height: 28px;
                        }

                        p:last-child {
                            width: 330px;
                            height: 21px;
                            font-size: 15px;
                            font-weight: 400;
                            color: rgba(51, 51, 51, 1);
                            line-height: 21px;
                            margin-right: 197px;
                            margin-top: 10px;
                        }
                    }
                }
            }
        }

        .ts_content {
            padding: 30px;

            .ts_content_fr {
                display: flex;
                justify-content: flex-start;

                p {
                    width: 70px;
                    text-align: left;
                    margin-right: 10px;
                    white-space: normal;
                }
            }
        }

        .goOrderEsc {
            margin-top: 20px;
            width: 137px;
            height: 42px;
            background: rgba(255, 216, 0, 1);
            border-radius: 2px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            line-height: 42px;
            outline: none;
            border: none;
            cursor: pointer;
        }
    }

    .shoetext {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 150px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: inline-block;
        margin-top: 10px;
        margin-left: 10px;
    }

    .upload_progress_one {
        width: 138px;
        height: 38px;
        border: 1px solid #F7B500;
        border-radius: 4px;
        margin: 0 2px 8px 0;
        font-size: 14px;
        text-align: center;
        line-height: 38px;
        color: #F7B500;
        position: relative;

        .upload_progress_one_shadow {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background: rgba(255, 216, 0, 0.3);
            border-radius: 4px;
            transition: all .5s;
        }
    }
</style>